<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form
        :inline="true"
        size="small"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="用工申请联系名称">
          <el-input
            placeholder="请输入用工申请联系名称"
            v-model="formInline.search"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button
        size="small"
        icon="el-icon-plus"
        type="primary"
        @click="addClick"
        >添加用工申请联系</el-button
      >
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table
            size="small"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column
              prop="applicant_name"
              label="申请人"
            ></el-table-column>
            <el-table-column
              prop="applicant_phone"
              label="申请人联系方式"
            ></el-table-column>
            <el-table-column
              prop="job_seeker_name"
              label="被申请人"
            ></el-table-column>
            <el-table-column
              prop="job_seeker_phone"
              label="被申请人联系方式"
            ></el-table-column>
            <el-table-column prop="name" label="项目名称"></el-table-column>
            <el-table-column prop="status" label="雇佣状态">
              <template slot-scope="scope">
                <span class="gray9" v-if="scope.row.status == 0">提交中</span>
                <span class="green" v-if="scope.row.status == 1">已雇佣</span>
                <span class="red" v-if="scope.row.status == 2">未被雇佣</span>
                <span class="orange" v-if="scope.row.status == 3"
                  >已被解雇</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="apply_count"
              label="被雇佣次数"
              :formatter="row => `${row.apply_count || 0}次`"
            >
            </el-table-column>
            <el-table-column
              prop="reject_val"
              label="拒绝原因"
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="申请联系时间"
            ></el-table-column>

            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button
                  v-if="
                    scope.row.status == 0 ||
                      scope.row.status == 2 ||
                      scope.row.status == 3
                  "
                  @click="passClick(scope.row)"
                  type="text"
                  size="small"
                  >雇佣</el-button
                ><br />
                <el-button
                  v-if="scope.row.status == 0 || scope.row.status == 3"
                  @click="nopassClick(scope.row)"
                  type="text"
                  size="small"
                  >不雇佣</el-button
                ><br />
                <el-button
                  v-if="scope.row.status == 1"
                  @click="dismissClick(scope.row)"
                  type="text"
                  size="small"
                  >解雇</el-button
                ><br />
                <el-button
                  @click="editClick(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  @click="deleteClick(scope.row)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit
      :open_add="open_edit"
      :contact_id="contact_id"
      v-if="open_edit"
      @close="closeEdit"
    ></Edit>

    <el-dialog
      style="text-align: center"
      title="设置标题"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
    </el-dialog>
  </div>
</template>

<script>
import ContactApi from "@/api/contact.js";
import Add from "./part/add.vue";
import Edit from "./part/edit.vue";

export default {
  components: {
    Add,
    Edit
  },
  inject: ["reload"],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: ""
      },

      open_add: false,
      open_edit: false,
      contact_id: "",
      dialogVisible: false
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    dialogFormVisible() {
      this.dialogVisible = false;
    },
    setting(e) {
      //用工申请联系标题设置
      // this.categorya_id = e
      this.dialogVisible = true;
    },
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    getData() {
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      ContactApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true;
    },

    /*编辑活动*/
    editClick(row) {
      this.contact_id = row.contact_id;
      this.open_edit = true;
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          ContactApi.del(
            {
              contact_id: row.contact_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.getTableList();
              } else {
                self.$message.error("错了哦，这是一条错误消息");
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    passClick(item) {
      //退款申请-通过审核
      var self = this;
      var Params = {
        contact_id: item.contact_id,
        status: 1
      };
      ContactApi.passCanel(Params, true)
        .then(data => {
          console.log(data);
          if (data.code == 1) {
            self.$message({
              type: "success",
              message: "审核成功"
            });
            self.getTableList();
            return false;
          }
        })
        .catch(error => {});
    },
    async nopassClick(item) {
      //不通过的原因
      var self = this;
      const reject_val = await this.promptInput("请输入不通过的原因");

      // 添加检查：如果用户取消输入，直接返回
      if (reject_val === undefined || reject_val === null) {
        this.$message({
          type: "info",
          message: "已取消操作"
        });
        return;
      }

      // 添加验证：确保用户输入了原因
      if (!reject_val.trim()) {
        this.$message({
          type: "warning",
          message: "请输入不通过的原因"
        });
        return;
      }

      var Params = {
        contact_id: item.contact_id,
        status: 2,
        reject_val: reject_val.trim()
      };

      ContactApi.passCanel(Params, true)
        .then(data => {
          if (data.code == 1) {
            self.$message({
              type: "success",
              message: "审核成功"
            });
            self.getTableList();
          } else {
            // 添加错误处理
            self.$message.error(data.msg || "操作失败");
          }
        })
        .catch(error => {
          self.$message.error("网络错误，请重试");
        });
    },
    async dismissClick(item) {
      //解雇操作
      var self = this;
      const reject_val = await this.promptInput("请输入解雇原因");

      // 添加检查：如果用户取消输入，直接返回
      if (reject_val === undefined || reject_val === null) {
        this.$message({
          type: "info",
          message: "已取消操作"
        });
        return;
      }

      // 添加验证：确保用户输入了原因
      if (!reject_val.trim()) {
        this.$message({
          type: "warning",
          message: "请输入解雇原因"
        });
        return;
      }

      var Params = {
        contact_id: item.contact_id,
        status: 3,
        reject_val: reject_val.trim()
      };

      ContactApi.passCanel(Params, true)
        .then(data => {
          if (data.code == 1) {
            self.$message({
              type: "success",
              message: "解雇成功"
            });
            self.getTableList();
          } else {
            self.$message.error(data.msg || "操作失败");
          }
        })
        .catch(error => {
          self.$message.error("网络错误，请重试");
        });
    },
    async promptInput(message, validation) {
      try {
        const { value } = await this.$prompt(message, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputErrorMessage: validation
        });
        return value.trim();
      } catch (e) {
        this.$message({
          type: "info",
          message: "取消输入"
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/contact/index/index.vue